import isProduction from './is-prod';

const fbTracking = process.browser && isProduction ? window.fbq : () => {}

export default fbTracking